export function flattenTree(tree: any): any[] {
  if (!tree.components) {
    return [];
  }

  const compoTree = JSON.parse(JSON.stringify(tree));

  const arr: any[] = [];

  visitChildren(compoTree, arr);

  return arr;
}

function visitChildren(component: any, arr: any[]): void {
  component.components?.map((child: any) => {
    arr.push(child);
    visitChildren(child, arr);
  });
}
